const template = `
	<div>
		<h1>{{ ii('FULL_ACCESS_REQUIRED') }}</h1>
	</div>
`;

export default {
	_cssUrl: null,
	template
}